export default __webpack_public_path__ + "static/royal_greatsword-8a9df793e43caf0ee51afb6daff38c7b.png";